import React from 'react'
import clsx from 'clsx'
import { Icon } from '../Icon'
import styles from './styles.module.scss'

export type AddButtonProps = {
  onClick?: () => void
} & React.StyledProps

export const AddButton: React.StyledFC<AddButtonProps> = ({
  className,
  onClick,
}: AddButtonProps) => {
  return (
    <button
      type="button"
      className={clsx(styles.button, className)}
      onClick={onClick}
    >
      <span className={styles.iconWrapper}>
        <Icon icon="plus" />
      </span>
    </button>
  )
}
